export default "__VITE_ASSET__BB5dA0zQ__"